import { render, staticRenderFns } from "./TravelBulletinBoard.vue?vue&type=template&id=5e414d9f&scoped=true"
import script from "./TravelBulletinBoard.vue?vue&type=script&lang=js"
export * from "./TravelBulletinBoard.vue?vue&type=script&lang=js"
import style0 from "./TravelBulletinBoard.vue?vue&type=style&index=0&id=5e414d9f&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e414d9f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitHub\\ita.GroupTravel.Website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e414d9f')) {
      api.createRecord('5e414d9f', component.options)
    } else {
      api.reload('5e414d9f', component.options)
    }
    module.hot.accept("./TravelBulletinBoard.vue?vue&type=template&id=5e414d9f&scoped=true", function () {
      api.rerender('5e414d9f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ita/components/TravelBulletinBoard.vue"
export default component.exports